import { useStoreState } from 'easy-peasy';

const useServiceGroupSearch = (filterText = '') => {
  const lowerCaseFilterText = (filterText || '').toLowerCase();
  const serviceGroupsSites = useStoreState((state) => state.sites.getViewServiceGroupsSites);
  const serviceGroups = serviceGroupsSites
    .filter((g) => g.name.toLowerCase().includes(lowerCaseFilterText))
    .map((group) => {
      return {
        id: group.id,
        name: group.name,
      };
    });
  return { serviceGroups: serviceGroups };
};

export default useServiceGroupSearch;
